import React, { PureComponent } from 'react'
import { DateFormat } from '@lingui/react'

type DateType = 'default' | 'date-month-long' | 'date-month-long-year'

type Props = {
  date: Date
  kind: DateType
}

export default class ReadableDate extends PureComponent<Props> {
  static defaultProps = {
    kind: 'default',
  }

  getFormat() {
    switch (this.props.kind) {
      case 'date-month-long-year':
        return { month: 'long', day: 'numeric', year: 'numeric' }
      case 'date-month-long':
        return { month: 'long', day: 'numeric' }
      default:
        return { month: 'numeric', day: 'numeric', year: 'numeric' }
    }
  }

  render() {
    const { date } = this.props

    return <DateFormat value={date} format={this.getFormat()} />
  }

  renderDefault(date: Date) {
    // use the localized default for date; which will be day, month and year
    // (in numeric format and locale-specific order)
    return (
      <DateFormat
        value={date}
        format={{ month: 'numeric', day: 'numeric', year: 'numeric' }}
      />
    )
  }
}
